import { HttpClient, HttpParams } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { RegistrationPackageOption } from '../interfaces/registration-package.interface'
import { environment } from 'src/environments/environment'
import { map, Observable } from 'rxjs'
import { ApiResponse } from 'src/app/shared/interfaces/api-response/api-response.interface'
import { Registration } from '../interfaces/registration.interface'
import { XeroPreRegistration } from '../interfaces/xero-pre-registration.interface'

@Injectable({
    providedIn: 'root',
})
export class RegisterService {
    #httpClient = inject(HttpClient)

    register(companyDetails: Registration): Observable<string | null> {
        return this.#httpClient
            .post<ApiResponse<string | null>>(`${environment.baseUrl}registration`, companyDetails)
            .pipe(map((response) => response.result))
    }

    getPackages(): Observable<RegistrationPackageOption[]> {
        return this.#httpClient
            .get<ApiResponse<RegistrationPackageOption[]>>(`${environment.baseUrl}registration/packages`)
            .pipe(map((x) => x.result))
    }

    xeroCallback(code: string, state: string): Observable<XeroPreRegistration> {
        return this.#httpClient
            .post<
                ApiResponse<XeroPreRegistration>
            >(`${environment.baseUrl}registration/xero/callback?code=${code}&state=${state}`, {})
            .pipe(map((response) => response.result))
    }
}
